import React from "react";
import ManagementList from "../../components/Prospects/ManagementList";
const ProspectsGestion = () => {
  return <ManagementList />;
};

export default ProspectsGestion;
